import en from './en-US';
import es from './es-ES';
import fr from './fr-FR';

export default {
    ...en,
    ...es,
    ...fr,
}